import * as Flickity from 'flickity';

export default function() {
    function init() {
        const image = document.querySelector('.js-testimonial_image_slider');
        const flickityImage = new Flickity( image, {
            cellAlign: 'left',
            resize: true,
            contain: true,
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true,
            on: {
                change: function( index ) {
                    flickityText.select( index );
                    const indexLabel = document.querySelector('.js-slider-index');
                    indexLabel.innerHTML = `0${index + 1}`;
                }
            }
        });

        const text = document.querySelector('.js-testimonial_text_slider');
        const flickityText = new Flickity( text, {
            draggable: false,
            contain: false,
            pageDots: false,
            prevNextButtons: false,
            fade: true
        });

        const prevButton = document.querySelector('.js-slider-prev');
        prevButton.addEventListener('click', (e) => {
            flickityImage.previous();
        });
        const nextButton = document.querySelector('.js-slider-next');
        nextButton.addEventListener('click', (e) => {
            flickityImage.next();
        });
    }

    if(document.querySelector('.js-testimonial_image_slider')) {
        init();
    }
}
